/**
 * Install a `URL.parse` polyfill for browsers that lack it (notably Safari < 18).
 *
 * pdfjs-dist's modern build calls `URL.parse` when resolving document URLs.
 * Without this, `react-pdf` / `getDocument` crashes on Safari 17 with:
 * `TypeError: URL.parse is not a function`.
 *
 * Spec: https://url.spec.whatwg.org/#dom-url-parse
 * Returns `null` on failure instead of throwing (unlike `new URL(...)`).
 */
export function installUrlParsePolyfill(
  target: typeof globalThis = globalThis
): void {
  const URLCtor = target.URL;
  if (typeof URLCtor !== 'function') return;
  if (typeof URLCtor.parse === 'function') return;

  URLCtor.parse = (url: string | URL, base?: string | URL): URL | null => {
    try {
      return base === undefined ? new URLCtor(url) : new URLCtor(url, base);
    } catch {
      return null;
    }
  };
}
